import { Navigate } from 'react-router-dom';

const PermissionRoute = ({ permission, component }) => {
  return permission ? component : <Navigate to="/unauthorized" replace />;
};

export default PermissionRoute;
